import styled from "styled-components"

export const Container = styled.div`
    max-width: 3840px;
    max-height: 2676px;
`

export const Wrapper = styled.div`
    width: 100%;
    height: 0px;
    position: relative;
    left: 0px;
    padding-bottom: 69.6875%;
    overflow: hidden;
`

export const StyledIframe = styled.iframe`
    width: 1px;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    min-width: 100%;
    *width: 100%;
    border: none;
`